import { render, staticRenderFns } from "./Publicity.vue?vue&type=template&id=4a00a9d2&scoped=true&"
import script from "./Publicity.vue?vue&type=script&lang=js&"
export * from "./Publicity.vue?vue&type=script&lang=js&"
import style0 from "./Publicity.vue?vue&type=style&index=0&id=4a00a9d2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00a9d2",
  null
  
)

export default component.exports